export default __webpack_public_path__ + "static/media/busstopsign.f691ba73.jpg";